import { render, staticRenderFns } from "./IndexGenericMultiTable.vue?vue&type=template&id=57d1fb66&scoped=true&"
import script from "./IndexGenericMultiTable.vue?vue&type=script&lang=ts&"
export * from "./IndexGenericMultiTable.vue?vue&type=script&lang=ts&"
import style0 from "./IndexGenericMultiTable.vue?vue&type=style&index=0&id=57d1fb66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d1fb66",
  null
  
)

export default component.exports